import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography
} from "@material-ui/core";
import styled from "styled-components";
import PropTypes from "prop-types";
import { withTheme } from "@material-ui/core/styles";
import Dialog from "../../../waybee-ui/Dialog";
import ClassService from "../../../services/ClassService";

const ReportText = styled(Typography)`
  margin: 16px 0 24px 0;
`;

const DownloadButton = styled.a`
  text-decoration: none;
  color: ${({ color }) => color};
`;

function ReportDialog(props) {
  const [loading, setLoading] = useState(false);
  const [reportFileReady, setReportFileReady] = useState(false);
  const [file, setFile] = useState();
  const { open, report, onClose, theme } = props;
  const createReport = async () => {
    setLoading(true);
    return ClassService.createReport(report).then(res => {
      setFile(res);
      setLoading(false);
      setReportFileReady(true);
    });
  };

  return (
    <Dialog scroll="body" closeButton open={open} onClose={onClose} fullWidth>
      {loading ? (
        <Box p={6} textAlign="center">
          <Typography variant="h2" style={{ paddingBottom: 15 }}>
            Gerando Relatório...
          </Typography>
          <CircularProgress />
        </Box>
      ) : (
        <Box p={3} textAlign="center">
          {reportFileReady ? (
            <>
              <Typography variant="h2">{report.name}</Typography>
              <ReportText variant="body1">
                {`"${report.name}" pronto para baixar`}
              </ReportText>
              <Grid container justify="space-evenly">
                <Button variant="contained" color="primary">
                  <DownloadButton
                    color={theme.palette.default.contrastText}
                    download={report.name}
                    href={file}
                  >
                    Baixar
                  </DownloadButton>
                </Button>
              </Grid>
            </>
          ) : (
            <>
              <Typography variant="h2">{report.name}</Typography>
              <ReportText variant="body1">
                {`Deseja gerar o relatório "${report.name}"? Ao confirmar não saia da tela, aguarde o processo finalizar.`}
              </ReportText>
              <Grid container justify="space-evenly">
                <Button variant="contained" onClick={onClose}>
                  Cancelar
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => createReport()}
                >
                  Gerar
                </Button>
              </Grid>
            </>
          )}
        </Box>
      )}
    </Dialog>
  );
}

ReportDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  report: PropTypes.objectOf().isRequired,
  onClose: PropTypes.func.isRequired,
  theme: PropTypes.objectOf().isRequired
};

export default withTheme(ReportDialog);
